var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-rain-alarm"},[_c('alarm-status',{attrs:{"alarm":_vm.alarm,"alarm-active":_vm.computedAlarmIsActive}}),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }